import { HttpClient } from '@angular/common/http';
import { map, tap } from 'rxjs/operators';
// Services.
import { LoggerService } from '../logger/logger.service';
// Classes.
import { Logger } from '../../classes/logger';
import { LanguageService } from '../lang/language.service';
import { Interpretations } from '../../classes/interpretations';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../logger/logger.service";
import * as i3 from "../lang/language.service";
export class FetchService {
    constructor(http, loggerSrvc, lang) {
        this.http = http;
        this.lang = lang;
        this.apiUrl = 'https://api.worldarchery.sport/v3/';
        this.logger = new Logger(loggerSrvc, this.constructor.name);
    }
    getApiURL() {
        return this.apiUrl;
    }
    /**
     * Fetches an article from the Rulebook.
     * https://api.worldarchery.sport/v3/API/RB-Article
     */
    getArticle(id) {
        let url = this.apiUrl + 'RB-ARTICLE/?ArticleID=' + id;
        return this.http.get(url).pipe(map(response => this.processArticleResponse(response)), tap(items => this.logger.log(`Received items from "${url}"`, items)));
    }
    /**
     * Process this.article http response.
     *
     * Always return first element.
     */
    processArticleResponse(data) {
        return data.items[0];
    }
    /**
     * Index.
     * Returns the main index of the rulebook from the given article id.
     * https://api.worldarchery.sport/v3/API/RB-Index
     */
    getIndex(id) {
        let url = this.apiUrl + 'RB-INDEX/?ArticleID=' + id;
        this.logger.log(`Requesting index "${id}" to URL "${url}"`);
        return this.http.get(url).pipe(map(response => this.processIndexResponse(response, id), tap(items => this.logger.log(`Received index items from "${url}"`, items))));
    }
    /**
     * Process this.index http response.
     *
     * If id requested is 0 we wrap results in a ghost item to always return
     * a single item. If not, we have tio return an array of items.
     */
    processIndexResponse(data, id) {
        let response;
        if (id == "0") {
            response = {
                kicker: "Rulebook",
                title: "Rulebook container article",
                number: 0,
                order: 0,
                id: "0",
                type: "txt",
                parent: null,
                level: 0,
                pdf: "",
                children: data.items
            };
        }
        else {
            response = data.items[0];
        }
        return response;
    }
    /**
     * Image.
     * Returns an image from Rulebook. The image is base64-encoded.
     * https://api.worldarchery.sport/v3/API/RB-Image
     */
    getImage(id) {
        let url = this.apiUrl + 'RB-IMAGE/?ImageID=' + id;
        return this.http.get(url).pipe(map(response => this.processImageResponse(response)), map(rawImage => rawImage));
    }
    processImageResponse(data) {
        return data.items[0];
    }
    /**
     * Search.
     * Returns a list of articles where the text is found in kicker, title or text.
     */
    search(text, page) {
        // https://api.worldarchery.sport/v3/API/RB-Search
        let url = this.apiUrl + 'RB-SEARCH/?fText=' + text;
        if (page) {
            url += '&Page=' + page;
        }
        return this.http.get(url).pipe(map(response => this.processSearchResponse(response)));
    }
    processSearchResponse(data) {
        return data;
    }
    /**
     * Flying page.
     *
     * Returns a flying page.
     */
    getFlyingPage(id) {
        // https://api.worldarchery.sport/v3/API/RB-Search
        let url = this.apiUrl + 'RB-PAGE/?RBPage=' + id;
        return this.http.get(url).pipe(map(response => this.processFlyingPageResponse(response)));
    }
    processFlyingPageResponse(data) {
        return data.items[0];
    }
    /**
     *
     *  Get interpretations from api call
     * @returns
     * @memberof FetchService
     */
    getInterpretations() {
        const url = this.apiUrl + 'RB-Interpretation/';
        return this.http.get(url).pipe(map((response) => response.items.map(data => new Interpretations(data))));
    }
}
FetchService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function FetchService_Factory() { return new FetchService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.LoggerService), i0.ɵɵinject(i3.LanguageService)); }, token: FetchService, providedIn: "root" });
